import guideData from './shared/state';

export default {
  modules: {
    guideData,
  },
};
